import * as React from "react";
import type { SVGProps } from "react";
const WebDesignAgency = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#clip0_4362_7555)">
      <path
        fill="currentColor"
        d="M2 5.125c0-1.5168 1.2332-2.75 2.75-2.75h16.5c1.5168 0 2.75 1.2332 2.75 2.75v13.75c0 1.5168-1.2332 2.75-2.75 2.75H4.75c-1.5168 0-2.75-1.2332-2.75-2.75zm2.75 2.75v11h6.875v-11zm16.5 0h-6.875v11h6.875z"
      />
    </g>
    <defs>
      <clipPath id="clip0_4362_7555">
        <path fill="transparent" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default WebDesignAgency;
